import { useContext, useEffect, useState } from "react"
import { checkError, fetchTypeAheadTerms } from "../utils/utils"
import { Button, Col, Form, Row } from "react-bootstrap"
import { Menu, MenuItem, Typeahead } from 'react-bootstrap-typeahead';
import axios from "axios"
import { api } from "../services/config"
import { ProjectContext } from "../screens/ProjectScreen"

function AddBulkSC({
    modelShow, setModelShow,
    modelDataType, setModelData,
    setRowsSelected,
    projectId,
    termList_, selectedTerms,
}
) {
    const {
        setProjectState, setTreeState,
        headers,
    } = useContext(ProjectContext);
    const [hypernymSC, setHypernymSC] = useState([])
    const [termsHsc, setTermsHsc] = useState([])
    const [queryHsc, setQueryHsc] = useState({
        'surface_regex': "",
        'sort': (["reference"]),
        "is_vedette": true
    })
    const [loading, setLoading] = useState(false)
    const [validated, setValidated] = useState(false);
    const [checked, setChecked] = useState(false)

    useEffect(() => {
        if (modelShow && modelDataType === "add_class") {

            setLoading(false)
            if (queryHsc !== undefined && queryHsc.length !== 0) fetchTypeAheadTerms(projectId, queryHsc, setTermsHsc, setLoading)
        }
    }, [queryHsc, projectId, modelShow, modelDataType])

    const onChangeHypernymSC = (data) => {
        setHypernymSC(data)
    }

    const sHCHandleInputChange = query => {
        setTermsHsc([])
        setQueryHsc({
            'surface_regex': query ? `(^${query})` : "",
            'sort': (["reference"]),
            "is_vedette": true,
        });
    };

    return (<>
        <p>Vous avez demandé la création de <strong>{selectedTerms.length}</strong> classes</p>
        {termList_.length > 0 && <div className="mb-3">
            <p>
                Veuillez noter que certains des termes que vous avez sélectionnés pour créer des classes sont déjà des termes vedettes et ne peuvent pas être utilisés.
            </p>
            <p> Voici la liste de ces termes:</p>
            <ul className="list_terms">
                {termList_.map(term => <li>{term.reference}</li>)}
            </ul>
        </div>}
        <Form noValidate validated={validated} >
            <Form.Group as={Row} className="mb-3" controlId="">
                <Form.Label column sm="4" xs="12">
                    Hyperonyme
                </Form.Label>
                <Col sm="8" xs="12">
                    <Typeahead
                        selected={hypernymSC}
                        isInvalid={checked && (queryHsc.surface_regex.length !== 0)}
                        className={checked && (queryHsc.surface_regex.length !== 0) ? "is-invalid" : ""}
                        id="search-class"
                        onChange={data => {
                            onChangeHypernymSC(data);
                            setQueryHsc({
                                ...queryHsc,
                                surface_regex: ""
                            });
                        }}
                        labelKey="reference"
                        renderMenu={(results, menuProps) => (
                            <Menu {...menuProps}>
                                {results.map((result, index) => (
                                    <MenuItem option={result} position={index}>
                                        <span>
                                            {result.reference}
                                        </span>
                                        <span className="opacity-50 f-s-13 ">
                                            {result?.form?.source?.label}
                                        </span>
                                    </MenuItem>
                                ))}
                            </Menu>
                        )}
                        emptyLabel={!(queryHsc !== undefined && queryHsc.length !== 0) ? "Commencer à saisir..." : !loading ? "Recherche..." : "Aucune correspondance trouvée"}
                        options={termsHsc}
                        onInputChange={sHCHandleInputChange}
                        placeholder="Sélectionnez une classe..."
                        style={{ flex: 1 }}
                    />
                    <Form.Control.Feedback type="invalid"> Veuillez renseigner une valeur existante.</Form.Control.Feedback>
                </Col>
            </Form.Group>
        </Form>
        <Button className='m-3 p-1' size="sm" onClick={() => {
            setChecked(true);
            const terms = selectedTerms.map(term => term.id)
            if (queryHsc.surface_regex.length === 0) {
                setValidated(true);
                setChecked(false);
                if (terms.length > 0) {
                    const data = {
                        bulk: true,
                        terms,
                        hypernyms: hypernymSC.map((i) => i.vedette_class),
                    };
                    axios.post(api.project + projectId + '/sc/', data, {
                        headers,
                    }).then(checkError).then(() => {
                        setProjectState(projectState => ({
                            ...projectState,
                            refresh: !projectState?.refresh
                        }));
                        const newTreeState = {
                            item: `terms-${data.terms}`,
                            updatedSemantics: data.hypernyms.length > 0 ? data.hypernyms : [0],
                        };
                        setTreeState(newTreeState);
                    }).catch(() => { });
                }

                setModelShow(false);
                setModelData({});
                setRowsSelected([]);
            }

        }}>
            Confirmer
        </Button>
    </>);
}
export default AddBulkSC;  